import React from 'react';
import styled from 'styled-components';
import Select from 'gatsby-theme-core/src/components/form-elements/select';
import Checkbox from './checkbox';
import Sizes from './sizes';
import useField from './hooks/use-field';

const getComponentByType = (type) => {
  switch (type) {
    case 'checkbox':
      return Checkbox;
    case 'select':
      return Select;
    case 'sizes':
      return Sizes;
    default:
      return Select;
  }
};

const SearchOptions = ({
  type = 'select',
  noSpacer,
  title,
  defaultOptionTitle,
  field,
  options,
  disabledWhenNoOptions,
  hideWhenNoOptions,
  multiSelect = false,
  className,
  ...props
}) => {
  const {
    options: defaultOptions,
    value,
    handler,
    arrayHandler,
  } = useField(field);

  const theOptions = options || defaultOptions;

  if (hideWhenNoOptions && theOptions.length === 0) {
    return null;
  }

  const Component = getComponentByType(type);

  return (
    <Options className={className}>
      {title && (
        <OptionTitle>{title}:</OptionTitle>
      )}
      <Component
        $noSpacer={noSpacer}
        name={field}
        currentValue={value}
        handler={multiSelect ? arrayHandler : handler}
        options={theOptions}
        defaultOptionTitle={defaultOptionTitle}
        disabledWhenNoOptions={disabledWhenNoOptions}
        {...props}
      />
    </Options>
  );
};

export const OptionTitle = styled.h3`
  font-size: 1rem;
  margin-bottom: .5rem;
  color: black;
`;

const Options = styled.div`
  font-weight: 500;
`;

export default styled(SearchOptions)``;
